<template>
  <section class="content-delete-account">
    <div class="content-delete-account-itens container">
      <div class="content-delete-account-itens-header">
        <h1>Exclusão de Conta no App Evolution: Um Guia Passo a Passo</h1>
      </div>
      <div class="content-delete-account-itens-body">
        <p>Se você é um usuário do app Evolution e deseja encerrar sua conta, este guia fornece um passo a passo simples para ajudá-lo a solicitar a exclusão de seus dados.
          O app Evolution é desenvolvido pela empresa Alpha Softwares e é amplamente conhecido por sua funcionalidade incrível.
          No entanto, se chegou o momento de se desvincular do app, siga as etapas a seguir:
        </p>

        <h2>Passo 1: Solicite a Exclusão da Conta</h2>
        <p>Para iniciar o processo de exclusão da conta no app Evolution, você deve primeiro enviar um e-mail de solicitação para o endereço de suporte do app Evolution <button @click="sendEmail()">(evolution@alphasoftwaresapps.com)</button> a partir do endereço de e-mail associado à sua conta no app.</p>

        <h2>Passo 2: Confirmação de Identidade</h2>
        <p>Após receber o seu e-mail de solicitação, a equipe de suporte da empresa Alpha Softwares entrará em contato com você para confirmar a sua identidade. Isso pode envolver a solicitação de informações específicas de conta, como o número de usuário ou um código de confirmação que será enviado para o seu e-mail registrado.</p>

        <h2>Passo 3: Revisão da Solicitação</h2>
        <p>Uma vez que a sua identidade tenha sido confirmada, a equipe de suporte revisará a sua solicitação para garantir que corresponda à conta que você deseja excluir.</p>

        <h2>Passo 4: Exclusão de Dados</h2>
        <p>A empresa Alpha Softwares procederá à exclusão da sua conta no app Evolution. Isso incluirá a remoção de informações pessoais, como nome, endereço de e-mail, histórico de atividade e quaisquer outros dados sensíveis que você tenha fornecido. No entanto, é importante notar que, de acordo com nossa política de privacidade, alguns dados podem ser mantidos por um período adicional para fins de registro ou cumprimento de obrigações legais.

          <h2>Passo 5: Confirmação da Exclusão</h2>
        <p>Após a exclusão da conta, você receberá um e-mail de confirmação informando que a sua conta no app Evolution foi excluída com sucesso e quaisquer dados associados a ela foram removidos.</p>
        <p>A equipe de suporte da empresa Alpha Softwares está comprometida em manter a segurança e a privacidade dos seus dados durante todo o processo. Lembre-se de que a exclusão de conta pode levar algum tempo, e o período de retenção de dados adicionais é necessário para cumprir as regulamentações de privacidade de dados.</p>
      </div>
    </div>
  </section>
</template>

<script>

export default {
  data() {
    return {
      emailEvolution: 'evolution@alphasoftwaresapps.com',
    }
  },
  methods: {
    sendEmail() {
      window.location.href=`mailto:${this.emailEvolution}`;
    },
  }
}
</script>

<style lang="scss">
.content-delete-account {
  padding-top: 70px;
  padding-bottom: 150px;
  text-align: left;
  @media (max-width: 767px){
    padding: 50px 30px 150px 30px;
  }
  &-itens {
    &-header {
      h1 {
        font-size: 24px;
        font-family: 'Font Semibold';
        color: var(--black);
        line-height: 1;
        margin-bottom: 30px;
      }
    }
    &-body {
      h2 {
        font-size: 20px;
        font-family: 'Font Semibold';
        color: var(--black);
        line-height: 1;
        margin: 30px 0px;
      }
      p {
        font-size: 16px;
        font-family: 'Font Light';
        color: var(--black);
        margin-bottom: 15px;
        button {
          display: inline-flex;
          background: 0;
          border: 0;
          padding: 0;
          color: var(--blue);
          text-decoration: underline !important;
        }
      }
    }
  }
}
</style>
